import {
  OfficeConsentNotFoundError,
  OfficeTnCTypeEnum,
  useAcceptAllOfficeConsents,
  useGetOfficeConsent,
} from '~/domain/Consents';
import { useUserSelector } from '~/hooks';
import { IToggleControls } from '~/hooks/useToggle';
import { IUser } from '~/models';

interface IUseRequireTnCAddendum {
  controls: IToggleControls;
  onSucceedAcceptConsent(): void;
}

export const useRequireTnCAddendum = ({
  controls,
  onSucceedAcceptConsent,
}: IUseRequireTnCAddendum) => {
  const currentUser: IUser = useUserSelector();

  const { data, error, isError } = useGetOfficeConsent({
    code: OfficeTnCTypeEnum.OFFICE_TNC_PERM,
    officeId: currentUser.id,
  });

  const { mutate, isPending } = useAcceptAllOfficeConsents({
    onError: controls.setOff,
    onSuccess: onSucceedAcceptConsent,
  });

  const doAcceptOfficeTnCPerm = () =>
    mutate({
      code: OfficeTnCTypeEnum.OFFICE_TNC_PERM,
      officeId: currentUser.id,
    });

  return {
    isAcceptingConsent: isPending,
    isConsentAccepted:
      !(isError && error instanceof OfficeConsentNotFoundError) && !!data?.isConsented,
    doAcceptOfficeTnCPerm,
  };
};
